module.exports = __webpack_public_path__ + "static/intel-f8bd88be75c8fe91409954c2fa255fcd.png";